import { Attrs, MinzeElement } from 'minze'

export interface LvcLanguageIcon {}

export class LvcLanguageIcon extends MinzeElement {
  attrs?: Attrs | undefined = [
    ['data-color', 'white'],
    ['data-width', '24'],
    ['data-height', '24'],
  ]

  html = () => `
    <svg width="${this.dataWidth}" height="${this.dataHeight}" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" stroke="${this.dataColor}" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M2 12H22" stroke="${this.dataColor}" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M12 2C14.5013 4.73835 15.9228 8.29203 16 12C15.9228 15.708 14.5013 19.2616 12 22C9.49872 19.2616 8.07725 15.708 8 12C8.07725 8.29203 9.49872 4.73835 12 2V2Z" stroke="${this.dataColor}" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  `

  css = () => `
  :host {
    display: flex;
  }
    
  `
}
